module.exports = __webpack_public_path__ + "img/cspace-googleplaystore.cc2cf4a7.svg";